import React, { useState, Fragment, useContext } from 'react'
import { useMusicPlayer } from '../../hooks/useMusicPlayer'
import { GlobalMusicContext } from '../../context/GlobalMusicContext'
import { MusicPlayerContext } from '../../context/MusicPlayerContext'
import { useHistory } from 'react-router-dom'
import { VolumeSlider } from '../helpers/VolumeSlider'
import { Text } from '@chakra-ui/react'
import { ReactComponent as PauseSvg } from '../../assets/pause.svg'
import { ReactComponent as PlaySvg } from '../../assets/play.svg'
import { ReactComponent as FastForward } from '../../assets/fast-forward.svg'
import { ReactComponent as FastRewind } from '../../assets/fast-rewind.svg'
import defaultImg from '../../assets/music.jpeg'

import { RiHeartLine, RiShuffleLine } from 'react-icons/ri'
import { RepeatIcon } from '@chakra-ui/icons'
import { useRef } from 'react'

const formatTime = ( secs ) => {
  let minutes = Math.floor( secs / 60 )
  let seconds = Math.ceil( secs - minutes * 60 )
  if ( seconds < 10 ) seconds = `0${seconds}`
  return `0${minutes}:${seconds}`
}

export const TrackPlayControls = ( props ) => {
  // const {
  // 	currentSong,
  // 	songslist,
  // 	repeat,
  // 	random,
  // 	playing,
  // 	setCurrent,
  // 	prevSong,
  // 	nextSong,
  // 	toggleRepeat,
  // 	toggleRandom,
  // 	togglePlaying,
  // 	handleEnd,
  // } = useContext( PlayerContext )

  const [{ repeatOn, randomOn }, dispatch] = useContext( GlobalMusicContext )

  const toggleRepeatOn = ( id ) => dispatch( { type: 'TOGGLE_REPEAT', data: !state.repeat } )
  const toggleRandomOn = ( id ) => dispatch( { type: 'TOGGLE_RANDOM', data: !state.random } )

  // eslint-disable-next-line
  const { isPlaying, currentTrackName, currentTrackImg, otherTrackImg, togglePlay, playPreviousTrack, playNextTrack, onSeek, time, duration, trackProgress, currentTrack, toggleRepeat, handleSongEnded, toggleShuffle } = useMusicPlayer()

  const [liked, setLiked] = useState( false )
  const [state, setState] = useContext( MusicPlayerContext )
  const history = useHistory()

  let audio = useRef( 'audio_tag' )
  const toggleAudio = () => {
    audio.current.paused ? audio.current.play() : audio.current.pause()
  }

  const [volume, setVolume] = useState( 30 )
  const handleVolumeChange = ( newValue ) => {
    // state.audioPlayer.volume = parseFloat( newValue / 100 )
    audio.current.volume = parseFloat( newValue / 100 )
    setVolume( newValue )
    // if (event.cancelable) event.preventDefault();
  }

  // useEffect( () => {
  // 	audio.current.volume = volume
  // 	if ( isPlaying ) {
  // 		toggleAudio()
  // 	}
  // }, [] )

  return (
    <div className="players__inner">
      <audio ref={audio} onEnded={handleSongEnded}
      />
      <div className="player__info">
        {( currentTrackImg && otherTrackImg === undefined ) ? (
          <img
            src={`/static/${currentTrackImg}`}
            alt={currentTrackName}
            loading="lazy"
            className="track-img"
          />
        ) : (
          <img
            src={otherTrackImg && otherTrackImg + "?param=80y80"}
            alt={currentTrackName}
            loading="lazy"
            className="track-img"
          />
        ) ? <img src={otherTrackImg !== undefined ? otherTrackImg : defaultImg}
          alt="default-img"
          loading="lazy"
          className="default-img"
        />
          : null
        }

        {currentTrackName
          ? <Text
            as="span"
            fontWeight="light"
            fontSize={{ base: '0.75em', md: '1em', lg: '1.2em', xl: '1.2em' }}
          >
            {currentTrackName}
            <br />
            {currentTrack?.artists ? currentTrack?.artists[0]?.name : currentTrack?.ar[0]?.name}
          </Text>
          : <Text as="span" fontWeight="light"
            fontSize={{ base: '0.75em', md: '1em', lg: '1em', xl: '1em' }}
          >
            Track
            <br />
            Artists
          </Text>
        }
      </div>

      {/** To be changed UI & functionality */}
      <div className="player__controls">
        <div className="controls__wrapper">
          <button onClick={toggleRepeat}>
            <RepeatIcon
              color="white"
              w="0.8em"
              h="0.8em"
              cursor="pointer"
              mr="16px"
            />
          </button>
          <button
            className="button control__btns"
            onClick={playPreviousTrack}
            disabled={!currentTrackName}>
            <FastRewind className="rewind" />
          </button>
          <button
            className="button control__btns center"
            onClick={togglePlay}
            disabled={!currentTrackName}>
            {isPlaying
              ? <PauseSvg className="play" />
              : <PlaySvg className="pause" />
            }
          </button>
          <button
            className="button control__btns"
            onClick={playNextTrack}
            disabled={!currentTrackName}>
            <FastForward className="forward" />
          </button>
          <button onClick={toggleShuffle}>
            <RiShuffleLine
              style={{
                width: "0.65em",
                height: "0.65em",
                color: "white",
                marginLeft: "16px",
              }}
            />
          </button>
          <div className="progress__wrapper">
            <progress
              id="seek__obj"
              value={trackProgress}
              onClick={( e ) => onSeek( e )}
            >
            </progress>
            <span>
              {time ? formatTime( time ) : "00:00"} / {formatTime( duration )}
            </span>
          </div>
        </div>
      </div>
      {/** volumeSlider Warning: React does not recognize the `handleVolumeChange` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `handlevolumechange` instead. If you accidentally passed it from a parent component, remove it from the DOM element.*/}
      <div className="volume__wrapper">
        <VolumeSlider
          value={volume}
          onChange={handleVolumeChange}
        />
        <RiHeartLine
          style={{
            display: "inline-flex",
            color: "white",
            margin: "2px 16px 0 0"
          }}
          onClick={() => setLiked( !liked )}
        />
      </div>
    </div>
  )
}